import {useMemo} from 'react';
import {APP_LOCALE_STORAGE_KEY, DEFAULT_APP_LOCALE} from './i18n.types';
import {useI18nContext} from './I18nProvider';

export const useI18n = () => {
    const context = useI18nContext();

    return useMemo(() => ({
        ...context,
        defaultLocale: DEFAULT_APP_LOCALE,
        storageKey: APP_LOCALE_STORAGE_KEY
    }), [context]);
};
